<template>
 <div>
    <ListShell>
        <div id="tabel" class='my-table'>
            <div style="display:flex;display:-webkit-flex;">
                <div style="flex:1">
                    <slot name="Filter"></slot>
                </div>
                <div style="width:300px;text-align:right;">
                    <el-button style="color: #FFF; background-color: #409EFF; border-color: #409EFF;" @click="add" v-if="isAdd">Add +</el-button>
                </div>
            </div>
            <el-table :header-cell-style="{background:'#f5f7fa'}" :data="tableData" style="width: 100%;margin-top:20px;" align="center" border @selection-change="handleSelectionChange">
                <el-table-column
                    v-if="MultipleSel"
                    type="selection"
                    width="55">
                </el-table-column>
                
                <el-table-column v-for='(item,index) in tanle' :key="index" :label="item.label" align="center" :width='item.width'>
                    <template slot-scope="scope">
                        <template v-if="item.type == 1">
                            <div v-for="(subItem,index2) in scope.row[item.name]" :key="index2">
                            <span>{{ subItem | filterValue }}</span>
                            <br>
                            </div>
                        </template>
                        <template v-else-if="item.type == 'file'">
                            <div class="files-content" style="display:inline-block;width:calc(100% - 100px);">
                                <i class="el-icon-document"></i>
                            <a style="top: 4px;" class="files" @click="toggle(scope.row[item.name])" title="Download">{{ scope.row[item.name] | filterValue }}</a>
                            </div>
                        </template>

                        <template v-else-if="item.type == 'image'">
                            <div >
                                <img :src="scope.row[item.name]" style="width:50px; height:50px;">
                            <!--   <img src="@/assets/images/Authorized.png" > -->
                            </div>
                        </template>

                        <template v-else-if="item.type == 'word'">
                            <div class="files-content" style="display:inline-block;width:calc(100% - 100px);">
                            
                            <a style="top: 4px;" class="files" @click="jump(scope.row)" title="Info">{{ scope.row[item.name] | filterValue }}</a>
                            </div>
                        </template>

                        <template v-else-if="item.type == 'certification'">
                            <div class="files-content" style="display:inline-block;width:calc(100% - 100px);">
                                <div v-for="(subItem,index2) in scope.row[item.name]" :key="index2">
                                <a style="top: 4px;" class="files" @click="jump(scope.row,subItem)" title="Info">{{ subItem | filterValue }}</a>
                                <br>
                            </div>
                            </div>
                        </template>

                        <template v-else>
                            <span>{{ scope.row[item.name] | filterValue }}</span>
                        </template>
                    </template>
                </el-table-column>
                <el-table-column label="Operation" :width='operat.length * 40 + 80' align="center" fixed="right" v-if='operat.length !== 0'>
                    <template slot-scope="scope">
                        <template v-for="(operatBtn,index) in operat">
                            <template  v-if="operatBtn.text === 'Delete'">
                                <img class="btn-img" :key="index" v-if="!('method' in operatBtn) || operatBtn.method(scope.row)" src="@/assets/images/delete_icon.png" @click="operatEvent(operatBtn,scope.row)"  />
                            </template>
                            <template  v-else-if="operatBtn.text === 'Edit'">
                                <img class="btn-img" :key="index" v-if="!('method' in operatBtn) || operatBtn.method(scope.row)" src="@/assets/images/edit_icon.png" @click="operatEvent(operatBtn,scope.row)"  />
                            </template>
                            <template  v-else-if="operatBtn.text === 'Info'">
                                <img class="btn-img" :key="index" v-if="!('method' in operatBtn) || operatBtn.method(scope.row)" src="@/assets/images/view_icon.png" @click="operatEvent(operatBtn,scope.row)"  />
                            </template>
                            <template  v-else-if="operatBtn.text === 'Status'">
                                <img class="btn-img" :key="index" v-if="!('method' in operatBtn) || operatBtn.method(scope.row)" src="@/assets/images/Status_icon.png" @click="operatEvent(operatBtn,scope.row)"  />
                            </template>
                            <template  v-else-if="operatBtn.text === 'Download'">
                                <img class="btn-img" :key="index" v-if="!('method' in operatBtn) || operatBtn.method(scope.row)" src="@/assets/images/Download_icon.png" @click="operatEvent(operatBtn,scope.row)"  />
                            </template>
                            <!-- <el-button v-if="!('method' in operatBtn) || operatBtn.method(scope.row)" :type="operatBtn.type || ''" :key="index" @click="operatEvent(operatBtn,scope.row)">{{ operatBtn.text }}</el-button> -->
                        </template>
                    </template>
                </el-table-column>
                <div slot="empty">
                    No data
                </div>

            </el-table>
        
            <div style="position:relative;">
                <el-button v-if="MultipleSel"  @click="deleteMul" type="danger" icon='el-icon-delete' style="position:absolute;left:0;top:20px;"></el-button>
            </div>
        
        </div>
    </ListShell>    
    <div>
        <slot name="Tail"></slot>
    </div>
    <Pagination :total="total" @serch="changePage"></Pagination>
</div>
</template>

<script>
import Pagination from './Pagination';
import { deleteConfirm } from '@/methods/confirmBox';
import ListShell from "./ListShell";
export default {
    components:{
        Pagination,
        ListShell
    },
    props: {
        // 类表表头数据
        tanle: {
            required: true
        },
        isAdd:{
            default:true,
            type:Boolean
        },
        // 操作栏数据
        operat: {
            default() {
                return [{
                    text:"Modify",
                    eventName:"modify",
                    type:'primary'
                },{
                    text:"Delete",
                    eventName:"delete",
                    type:'danger',
                    PretreatMethod:"confirmDelete"
                }];
            }
        },
        // 请求url
        url: {
            type: String,
            required: true
        },
        deleteUrl: {
            type: String,
            default:""
        },
        // 请求后数据初步处理
        afterList: {
            type: Function, 
            default(data) {
                return data;
            }
        },
        // 请求额外参数
        data: {
            type:Object,
            default() {
                return {};
            }
        },
        // 显示多选删除项
        MultipleSel: {
            type:Boolean,
            default:false
        },
        // 更新列表数据
        update:{
            type:Number,
            default:0
        }
    },
    data() {
        return {
            tableData: [], //列表数据选项，从服务器获取
            total:20,
            row:10,
            pagenumber:1,
            multipleSelection:[]//多选存储器
        };
    },
    filters: {
        filterValue(value) {
            if(value === '' || value === null || value === 'undefined' || value === undefined)
                return '--';
            return value;
        }
    },
    mounted() {
        this.getList();
    },
    methods: {
        getList() {
            //获取列表数据
            this.data['row'] = this.row;
            this.data['page'] = this.pagenumber;
            //serchData  搜索条件绑定在data里  
            this.$http.get(this.url, this.data, (data)=>{
                this.tableData = this.afterList(data.data);
                this.total = Number(data.total);
            });
        }, 
        // 页数条数更改
        changePage (row,pagenumber) {
            this.row = row;
            this.pagenumber = pagenumber;
            this.getList();
        },
        handleSelectionChange (val) {
            this.multipleSelection = val;
        },
        // 操作事件触发器
        operatEvent (btnObj,ItemData) {
            ItemData = Object.assign({},ItemData);
            if(btnObj.PretreatMethod) this[btnObj.PretreatMethod](btnObj,ItemData);
            else this.$emit(btnObj.eventName,ItemData);
        },
        confirmDelete (btnObj,ItemData) {
            deleteConfirm(()=>{
                if(this.deleteUrl) {
                    this.$http.delete(this.deleteUrl,{
                        ID:ItemData.ID
                    },(data)=>{
                       
                        this.$baseNotice.message(data.msg);
                        this.getList();
                    });
                }else
                    this.$emit(btnObj.eventName,ItemData);
            });
        },
        deleteMul () {
            let data = [];
            for(let i in this.multipleSelection) data.push(this.multipleSelection[i].ID);
            data = data.join(";");
            this.$emit("deleteMul",data);
        },
        add () {
            this.$emit("add");
        },
        toggle (data) {
            //console.log(data)
            // this.iframeUrl = `${this.$http.host}akuvoxwiki/download/partnerManage/productMaterials/${data}`;
            this.$emit("download",data);
        },
        // 操作事件触发器
        jump (val,ItemData) {
            ItemData = Object.assign({},ItemData);
            this.$emit("jump",val,ItemData);
        }
    },
    watch: {
        update () {
            this.getList();
        }
    }
};
</script>

<style lang="less" scoped>
	.word-space{
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
		padding: 0 5px;
    }
    .files-content{
        padding: 5px 0;
        list-style: none;
        .files{
            text-decoration:underline;
            cursor: pointer;
            &:hover{
                color:#03a9f4;
            }
          
        }

    }
    .btn-img{
        padding: 0 10px;
        cursor: pointer;
    }
</style>